import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import { Form } from 'react-bootstrap-5';

export default class ContactFormSubsectionItem extends React.Component {
  static propTypes = {
    allowRemove: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    labelClassName: PropTypes.string,
    primary: PropTypes.bool,
    onPrimaryChange: PropTypes.func,
    onRemove: PropTypes.func
  }

  static defaultProps = {
    allowRemove: true
  }

  handlePrimaryChange = (event) => {
    this.props.onPrimaryChange(event.target.checked);
  }

  render() {
    return (
      <div className="contact-form-subsection-item">
        <div className="d-flex justify-content-between align-items-center pe-3 py-1">
          <Form.Label className={this.props.labelClassName}>{this.props.label}</Form.Label>

          <div className="d-flex align-items-center">
            {this.props.onPrimaryChange &&
              <label className="d-flex align-items-center gap-1">
                <input
                  checked={this.props.primary}
                  type="radio"
                  onChange={this.handlePrimaryChange}
                />
                Primary
              </label>
            }

            {!this.props.allowRemove ? null : (
              <FontAwesomeIcon
                className="ms-4 clickable"
                icon={faTrashAlt}
                name="remove"
                onClick={this.props.onRemove}
              />
            )}
          </div>
        </div>

        {this.props.children}
      </div>
    );
  }
}
